<template>
  <div class="main">
    <div class="nav">
      <van-nav-bar
        title="报告单选择"
        left-arrow
        left-text="返回"
        :fixed="true"
        @click-left="onClickLeft"
      />
    </div>
    <div class="reportBtnBox">
      <div class="checkedBtn" @click="checkedClick">检验报告单</div>
      <div class="examine" @click="examineClick">检查报告单</div>
      <!--            <div class="peisReport" @click="peisReportClick">体检报告</div>-->
    </div>
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import backindex from "@/mixins/backindex";
export default {
  name: "report_query",
  mixins: [setOptions, backindex],
  data() {
    return {
      clientId: "",
      name: "",
      age: "",
      item: null,
      CardNo: "",
      IDCardNo: "",
      lisid: "",
      pacsid: ""
    };
  },
  mounted() {
    if (this.$route.query.clientId) {
      console.log(this.$route.query);
      this.clientId = this.$route.query.clientId;
      
      this.name = this.$route.query.name;
      this.item = this.$route.query.item;
      // this.IDCardNo =   this.item.IDCardNo|| this.$route.query.IDCardNo;

      if (this.$route.query.CardNo) {
        this.CardNo = this.$route.query.CardNo;
      }
     
    }
    this.getReportId();
    if (!this.clientId || this.clientId === "") {
      this.$router.push("/patient_card_selectuser");
      return;
    }
  },
  methods: {
    async getReportId() {
      let url = "/report/getReport";
      // console.log(R_data)
      await this.$axios_request.axios_request_body(
        "nodeserver",
        url,
        "POST",
        null,
        data => {
          this.$hideLoad();
          this.lisid = data.data.lis;
          this.pacsid = data.data.pacs;

          // this.src.promise.then((pdf) => {
          //   this.numPages = hospitalChekedDetail.numPages;
          // });
        }
      );
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    checkedClick() {
      if (this.lisid == "0") {
            this.$router.push({
          path: "/dyLisList_D",
          query: {
            clientId: this.clientId,
            name: this.name,
            IDCardNo:!this.CardNo ? this.item.IDCardNo : this.CardNo
          }
        });
      } else {
        this.$router.push({
          path: "/hospitalCheckedReport_D",
          query: {
            clientId: this.clientId,
            name: this.name,
            // age: !this.age ? this.item.PatientAge : this.age,
            CardNo: !this.CardNo ? this.item.IDCardNo : this.CardNo
          }
        });
      }
    },
    examineClick() {
        if (this.pacsid == "0") {
            this.$router.push({
          path: "/dyPacsList_D",
          query: {
            clientId: this.clientId,
            name: this.name,
            IDCardNo :!this.CardNo ? this.item.IDCardNo : this.CardNo
          }
        });
      } else {
      this.$router.push({
        path: "/hospitalExamineReport_D",
        query: {
          clientId: this.clientId,
          name: this.name
        }
      });
      }
    },
    peisReportClick() {
      this.$router.push({
        path: "/ peisReport",
        query: {
          clientId: this.clientId,
          name: this.name
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  width: 100%;
  background-color: #eee;
  .nav {
    height: 6vh;
    .top {
      height: 6vh;
    }
  }
  .reportBtnBox {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .checkedBtn,
    .examine,
    .peisReport {
      width: 60%;
      height: 44px;
      border-radius: 44px;
      background: #5b8df6;
      margin-bottom: 20px;
      text-align: center;
      line-height: 44px;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>